// Конфигурация виджетов главного экрана.
// Чтобы управлять через бэкенд — добавить GET /api/v1/widgets/config
// и вместо этих констант делать fetch при монтировании приложения.

// ── Учебный календарь (плитка обратного отсчёта на главной) ──────────────
//
// Интервалы идут строго по возрастанию даты и не пересекаются. `end`
// эксклюзивный: день `end` относится уже к следующему периоду (сессия
// 14.12–02.01 означает, что 2 января — первый день каникул).
//
// Периода "учёба" в списке нет намеренно: это всё, что между интервалами.
// Так календарь не нужно переписывать целиком каждый семестр — достаточно
// дописать в конец очередную пару "сессия/каникулы".
//
// Последний интервал может иметь `end: null` — «до особого распоряжения»
// (тогда плитка не показывает счётчик, только название периода).
export const ACADEMIC_SCHEDULE = [
    // Зимняя сессия 2026/27
    { type: "session", start: new Date(2026, 11, 14), end: new Date(2027, 0, 2) },
    { type: "holidays", start: new Date(2027, 0, 2), end: new Date(2027, 0, 23) },
    // Летняя сессия 2026/27
    { type: "session", start: new Date(2027, 4, 10), end: new Date(2027, 4, 22) },
    { type: "holidays", start: new Date(2027, 4, 22), end: null },
];

const MS_PER_DAY = 24 * 60 * 60 * 1000;

function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

// Целых дней между датами. Считаем от полуночи до полуночи, иначе число
// «дней осталось» менялось бы в течение суток в зависимости от времени.
function daysBetween(from, to) {
    return Math.round((startOfDay(to) - startOfDay(from)) / MS_PER_DAY);
}

/**
 * В каком периоде учебного календаря находится дата.
 *
 * Возвращает:
 *   { phase: "session",        daysLeft }  — сессия идёт, N дней до конца
 *   { phase: "holidays",       daysLeft }  — каникулы, N дней до учёбы
 *                              daysLeft: null — каникулы без даты окончания
 *   { phase: "before_session", daysLeft }  — учёба, N дней до ближайшей сессии
 *   { phase: "study",          daysLeft: null } — календарь закончился,
 *                                                будущих сессий в нём нет
 */
export function resolveAcademicPhase(now = new Date()) {
    const today = startOfDay(now);

    for (const period of ACADEMIC_SCHEDULE) {
        const started = today >= startOfDay(period.start);
        const ended = period.end ? today >= startOfDay(period.end) : false;
        if (started && !ended) {
            return {
                phase: period.type,
                daysLeft: period.end ? daysBetween(today, period.end) : null,
            };
        }
    }

    // Ни в один интервал не попали — значит идёт учёба. Ищем ближайшую
    // будущую сессию, чтобы показать до неё отсчёт.
    const nextSession = ACADEMIC_SCHEDULE.find(
        (period) =>
            period.type === "session" && startOfDay(period.start) > today,
    );
    if (nextSession) {
        return {
            phase: "before_session",
            daysLeft: daysBetween(today, nextSession.start),
        };
    }

    return { phase: "study", daysLeft: null };
}
